import { useState } from 'react'
import { api, type AccountDetail } from '../lib/api.ts'
import { disabledIds, togglesChanged, withRuleToggled } from '../lib/ruleToggles.ts'
import { EntityForm, FieldGroup } from './EntityForm.tsx'
import { RuleList } from './RuleList.tsx'
import { useToast } from './Toast.tsx'

/**
 * The operational rules that run on an account's verifications, its page's
 * Regras operacionais tab (#688).
 *
 * The fifteen are ArtPharma's, some are specific to how one pharmacy works,
 * and a rule that is wrong for a pharmacy is worse than no rule -- so each
 * account says which run. This is the only place they are switched since the
 * screen of their own went (#687), and they are saved on their own.
 */
export function AccountRules({
  account,
  onSaved,
}: {
  account: AccountDetail
  onSaved: (next: AccountDetail) => void
}) {
  const [disabled, setDisabled] = useState(() => disabledIds(account.rules))
  const [saving, setSaving] = useState(false)
  const toast = useToast()

  const dirty = togglesChanged(account.rules, disabled)

  async function save() {
    setSaving(true)
    try {
      const r = await api.updateAccount(account.id, { disabledRules: disabled })
      onSaved(r.account)
      setDisabled(disabledIds(r.account.rules))
      toast.show('Regras salvas', { tone: 'success' })
    } catch (cause) {
      toast.show(cause instanceof Error ? cause.message : 'falha ao salvar', { tone: 'error' })
    } finally {
      setSaving(false)
    }
  }

  return (
    <EntityForm onSave={() => void save()} saving={saving} dirty={dirty}>
      <FieldGroup
        label="Regras operacionais"
        helperText="As regras que rodam nas conferências desta conta. Desligue as que não fazem sentido para esta farmácia; uma regra errada é pior do que nenhuma."
      >
        <RuleList
          rules={account.rules}
          disabled={disabled}
          windowDays={account.ruleFiredWindowDays}
          onToggle={(id, on) => setDisabled((current) => withRuleToggled(current, id, on))}
        />
      </FieldGroup>
    </EntityForm>
  )
}
